export const LOAD = 'ethstats/gasSpending/LOAD';
export const LOAD_SUCCESS = 'ethstats/gasSpending/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/gasSpending/LOAD_FAIL';
